/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect, useCallback } from "react";
// eslint-disable-next-line import/no-unresolved
import SettingIcon from "src/components/Icons/setting";
// eslint-disable-next-line import/no-unresolved
import UpArrow from "src/components/Icons/upArrow";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import * as Ui from "./styles";
import Tabs from "./Tabs";
import {
  EvolutiveCrossButton,
  evolutiveCrossButtonStyles,
} from "./components/Button";
import { ChainPlusIcon, SendIcon } from "src/components/Icons";
import { useEventBus, usePromptConfirmEvolutive } from "src/hooks";
import {
  ON_CHANGE_EVOLUTIVE_CROSS_BUTTON_STATE,
  ON_COMBINE_ALTERNATIVES,
  ON_COMBINE_QUESTIONS,
  ON_OPEN_SEND_COMBINATION_MODAL,
  ON_OPEN_SEND_ALTERNATIVE_MODAL
} from "src/hooks/EventBus/eventTypes";
import StepThree from "./StepThree";
import useFlashMessage from "src/hooks/FlashMessage";
import { StepManager } from "./managers";
import { COMBINED_ALTERNATIVES, COMBINED_QUESTIONS, EVOLUTIVE_CROSSING_NETWORK_ERROR, FINAL_PAYLOAD_SENT } from "src/sections/GroupCards/EvolutiveCrossChartCard/config/util/Constantes";
import { parseEvolutiveCrossConfig } from "./parsers";
import { storeEvolutiveCrossConfig } from "src/stores/actions/configs";

/**
 * Evolutive Container
 *
 * Obs: A responsabilidade de dimensionar corretamente a altura do 'evolutive-body'
 * fica por conta do componente filho.
 *
 */
export default function EvolutiveView({
  // define o nome do botão OK
  okBtnTitle = "AVANÇAR",
  // define o nome do botão Cancel
  cancelBtnTitle = "CANCELAR",
  // apresenta o pagina
  isOpen = false,
  // titulo da pesquisa selecionada no dashboard
  surveyTitle,
  // id da pesquisa selecionada
  surveyId,
  // titulo da questão selecionada no dashboard
  questionTitle,
  // Id da pergunta selecionada
  questionId,
  // id do cliente selecionado
  customerId,
  // propaga o evento de acionamento do botão Cancel
  onCancel,
  // propaga o evento de acionamento do botão Salvar (conclusão da criação da configuração)
  onSave,
  // outras propriedades
  ...props
}) {

  // from redux
  const { dispatch } = props;

  // Controle de estado de enable/disable do botão avançar
  const [nextButtonIsActive, setNextButtonIsActive] = useState(false);

  // Controla se exibe a mensagem de confirmação no passo 3
  const [haveItemToView, setHaveItemToView] = useState(false);

  // hooks
  const eventBus = useEventBus();

  // prompt
  const [openPromptConfirmEvolutive, renderPromptConfirmEvolutive] = usePromptConfirmEvolutive()

  //responsável pelas flash message
  const [handleFlashMessage] = useFlashMessage();

  // gerenciador de steps
  const stepManager = new StepManager();

  /**
   * Effects: Controla o estado do botão "avançar".
   */
  useEffect(() => {
    eventBus.subscribe(ON_CHANGE_EVOLUTIVE_CROSS_BUTTON_STATE, (state) => {
      // Evita set states desnecessários.
      if (state !== nextButtonIsActive) setNextButtonIsActive(state);
    });
  }, [nextButtonIsActive]);

  /**
   * Callbacks: Possui os verificadores de sucesso para cada step.
   */
  const handleOnCombineQuestionsClick = useCallback(() => {
    eventBus.notify(ON_COMBINE_QUESTIONS);
  }, []);

  /**
   * Callbacks: Notifica que um grupo de alternativas será combinadas
   */
  const handleOnCombineAlternativesClick = useCallback(() => {
    eventBus.notify(ON_COMBINE_ALTERNATIVES);
  }, []);

  /**
   * Callbacks: Notifica que um grupo de alternativas será enviada para um grupo de alternativas combinada
   */
  const handleOnSendAlternativesClick = useCallback(() => {
    eventBus.notify(ON_OPEN_SEND_ALTERNATIVE_MODAL);
  }, []);

  /**
   * Callbacks: Notifica para o Componente StepTwoLeftContent que a modal de envio de perguntas deve ser aberta.
   */
  const handleOnSendCombinationClick = useCallback(() => {
    eventBus.notify(ON_OPEN_SEND_COMBINATION_MODAL);
  }, []);

  function renderFooterOptions(renderType) {
    const isQuestionType = renderType === StepManager.constants.QUESTION_TYPE;

    // Label de renderização
    const label = isQuestionType ? "PERGUNTA" : "ALTERNATIVA";

    // Onclick handlers
    const combinationModalHandler = isQuestionType
      ? handleOnCombineQuestionsClick
      : handleOnCombineAlternativesClick;
    const sendCombinationModalHandler = isQuestionType
      ? handleOnSendCombinationClick
      : handleOnSendAlternativesClick;

    return (
      <Ui.CombineQuestions>

        <Ui.SendButton
          // disabled={combinationGroup.length && combinationGroup.length <= 1}
          onClick={sendCombinationModalHandler}
        >
          <SendIcon /> ENVIAR PARA UMA {label} COMBINADA
        </Ui.SendButton>

        <Ui.CombineButton
          disabled={stepManager.footerOptions.count <= StepManager.constants.STEP_TWO}
          onClick={combinationModalHandler}
        >
          <ChainPlusIcon /> COMBINAR {label}S
        </Ui.CombineButton>


      </Ui.CombineQuestions>
    );
  }

  function handleAllViewed(secondaries, visualized) {
    setHaveItemToView(() => {
      return secondaries.length !== visualized.length
    })
  }

  function handleSaveEvolutive() {
    const stepThreeData = [...StepManager.step_three_data];
    const stepOneData = [...StepManager.step_one_data];
  
    const payload = parseEvolutiveCrossConfig(surveyId, stepOneData, stepThreeData);

    const onError = () => {
      handleFlashMessage('Erro na requisição', 'Algo deu errado durante a requisição', 'error')
      if(onCancel) onCancel();
    }

    if (haveItemToView) {
      openPromptConfirmEvolutive(() => {
        // Realiza a requisição de criação da configuração
        storeEvolutiveCrossConfig(customerId, surveyId, payload, dispatch, onSave, onError);
      })
    } else {
      // Realiza a requisição de criação da configuração
      storeEvolutiveCrossConfig(customerId, surveyId, payload, dispatch, onSave, onError);
    }
  }

  // handle reset state
  function handleCancel() {
    if (onCancel) onCancel();
  }

  // conditional render
  if (!isOpen) {
    return null;
  }

  return (
    <Ui.Container>
      <Ui.Header>
        <Ui.Title>
          <div className="icon-wrapper">
            <SettingIcon className="icon" />
          </div>
          Configuração - Evolutivo de Cruzamentos
        </Ui.Title>
        <div className="locationName">
          <span onClick={() => handleCancel()}>DASHBOARD</span>
          <div className="svgWrapper">
            <UpArrow className="arrow" />
          </div>
          <span className="specificLocation">
            CONFIGURAÇÃO - EVOLUTIVO DE CRUZAMENTOS
          </span>
        </div>
      </Ui.Header>
      <Ui.TabsContainer>
        <Tabs
          title={"PASSO 1"}
          description={
            "Inicie a construção do evolutivo de cruzamentos, selecionando cruzamentos de outras avaliações para comparar com a Avaliação Atual"
          }
          handleClick={() => stepManager.onGoTo.call(stepManager, StepManager.constants.STEP_ONE)}
          isActive={stepManager.stepActive === StepManager.constants.STEP_ONE}
          isCompleted={stepManager.stepActive > StepManager.constants.STEP_ONE}
        />
        <Tabs
          title={"PASSO 2"}
          description={
            "Selecione e combine as perguntas secundárias dos cruzamentos escolhidos, para construir o comparativo em relação à Pergunta Principal"
          }
          handleClick={() => stepManager.onGoTo.call(stepManager, StepManager.constants.STEP_TWO)}
          isActive={stepManager.stepActive === StepManager.constants.STEP_TWO}
          isCompleted={stepManager.stepActive > StepManager.constants.STEP_TWO}
        />
        <Tabs
          title={"PASSO 3"}
          description={
            "Selecione e combine as alternativas dos grupos de perguntas combinados no passo anterior"
          }
          handleClick={() => stepManager.onGoTo.call(stepManager, StepManager.constants.STEP_THREE)}
          isActive={stepManager.stepActive === StepManager.constants.STEP_THREE}
          isCompleted={stepManager.stepActive > StepManager.constants.STEP_THREE}
        />
      </Ui.TabsContainer>
      <Ui.Body footerVisibility={stepManager.footerOptions.visible}>
        <StepOne
          visible={stepManager.stepOneIsVisible()}
          surveyTitle={surveyTitle}
          questionTitle={questionTitle}
          surveyId={surveyId}
          questionId={questionId}
          customerId={customerId}
        />

        <StepTwo
          visible={stepManager.stepTwoIsVisible()}
          surveyId={surveyId}
          questionTitle={questionTitle}
          questionId={questionId}
          customerId={customerId}
        />
        
        <StepThree
          handleAllViewed={handleAllViewed}
          visible={stepManager.stepThreeIsVisible()}
          surveyId={surveyId}
          customerId={customerId}
        />
      </Ui.Body>
      {stepManager.footerOptions.visible ? (
        renderFooterOptions(stepManager.footerOptions.type)
      ) : (
        <Ui.Actions>
          <EvolutiveCrossButton
            fillStyle={evolutiveCrossButtonStyles.outlined}
            type="button"
            title={stepManager.stepActive === StepManager.constants.STEP_ONE ? cancelBtnTitle : 'VOLTAR'}
            onClick={stepManager.stepActive === StepManager.constants.STEP_ONE ? handleCancel : stepManager.onBack.bind(stepManager)}
            clear
            className="cancelModalBtn"
          />
          <EvolutiveCrossButton
            fillStyle={evolutiveCrossButtonStyles.filled}
            type="button"
            title={stepManager.stepActive === StepManager.constants.STEP_THREE ? "SALVAR" : okBtnTitle}
            onClick={
              stepManager.stepActive === StepManager.constants.STEP_THREE ? handleSaveEvolutive : stepManager.onNext.bind(stepManager)
            }
            isDisabled={!nextButtonIsActive}
            className="okModalBtn"
          />
        </Ui.Actions>
      )}

      {renderPromptConfirmEvolutive(
        'Finalizar Evolutivo de Cruzamento?', 
        'Uma ou mais perguntas <strong>não foram visualizadas</strong>, deseja finalizar assim mesmo?',
        'Finalizar'
      )}

    </Ui.Container>
  );
}
